
import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from "@angular/core";
import { FuseLoadingService } from "./loading.service";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { loadingInterceptor } from "./loading.interceptor";


export const provideLoader = (): Array<Provider | EnvironmentProviders> => {
    const providers = [
        provideHttpClient(withInterceptors([loadingInterceptor])),
        provideEnvironmentInitializer(() => inject(FuseLoadingService)),
        
    ]

    return providers;
}